import {
  convertCentsIntoDollar,
  formatDate,
} from "../../../helpers/genericHelper";

export const nestedColumns = [
  {
    title: "Transaction Id",
    dataIndex: "transactionId",
    key: "index",
  },
  {
    title: "Failure Code",
    dataIndex: "failureCode",
    key: "failureCode",
  },
  {
    title: "Potential Fraud",
    dataIndex: "potentialFraud",
    key: "potentialFraud",
    render: (val) => (val === true || val === false ? val.toString() : ""),
  },
  {
    title: "Account Mask",
    dataIndex: "accountMask",
    key: "accountMask",
  },
];
export const mainColumns = [
  {
    title: "Account Name",
    dataIndex: "accountName",
    key: "name",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "Amount",
    render: (val) => <p>{convertCentsIntoDollar(val)}</p>,
  },
  {
    title: "Product Type",
    dataIndex: "productType",
    key: "product",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Start Time",
    dataIndex: "startTime",
    key: "start",
    render: (val) => <p>{formatDate(val, true)}</p>,
  },
  {
    title: "End Time",
    dataIndex: "endTime",
    key: "end",
    render: (val) => <p>{formatDate(val, true)}</p>,
  },
  {
    title: "Payment Mode",
    dataIndex: "paymentMode",
    key: "mode",
  },
  {
    title: "Payment Type",
    dataIndex: "paymentType",
    key: "type",
  },
];
